import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import RentalsHeroSection from './components/RentalsHeroSection';
import PropertiesSection from './components/PropertiesSection';

export default function Rentals() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <RentalsHeroSection />
        <PropertiesSection />
      </main>
      <Footer />
    </div>
  );
}